import { Typography } from "antd";
import { useIntl } from "react-intl";
import { AppsContainer } from "@lib/components/AppComponents";
import { AwaitingApprovalPayments } from "@lib/components/MiniComponents/Dashboard/Payment";
import useScreen from "@lib/hooks/useScreen";
import { SharedPaymentHistory } from "@app/shared";
import { StyledFlexDiv } from "@lib/components/StyledComponents";
import { Link } from "react-router-dom";
import { ROUTES } from "@lib/constants";
import { AppContext } from "@lib/types";

export default function ProviderDashboard() {
  const { messages } = useIntl();
  const { isMobile } = useScreen();

  return (
    <AppsContainer
      title={messages["common.dashboard"] as string}
      fullView
      cardStyle={{
        background: "transparent",
        boxShadow: "none",
      }}
    >
      {isMobile && <AwaitingApprovalPayments height="80vh" />}

      {!isMobile && (
        <SharedPaymentHistory
          withoutContainer
          height={410}
          context={AppContext.PAYMENT_PROVIDER}
          tableProps={{
            columnsConfig: {
              noFilter: true,
              noSort: true,
              noPagination: true,
              hiddenColumns: ["updatedBy", "id", "createdBy"],
            },
            header: {
              title: (
                <StyledFlexDiv style={{ gap: 10 }}>
                  <Typography.Text strong>
                    {messages["common.paymentHistory"] as string}
                  </Typography.Text>

                  <Link to={ROUTES.PROVIDER.PAYMENT_HISTORY.LIST}>
                    {messages["common.viewAll"] as string}
                  </Link>
                </StyledFlexDiv>
              ),
            },
          }}
        />
      )}
    </AppsContainer>
  );
}
